var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.divisions.length
        ? [
            !_vm.loading
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.getDivisions()
                      },
                    },
                  },
                  [_vm._v("Показать не активные\n      дивизионы\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
          ]
        : [
            _c(
              "div",
              { staticClass: "flex flex_gap_10 flex-wrap" },
              [
                _vm._l(_vm.divisions, function (d) {
                  return [_c("DivisionBtn", { attrs: { division: d } })]
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }